import script from "./MobileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileHeader.vue?vue&type=script&setup=true&lang=js"

import "./MobileHeader.vue?vue&type=style&index=0&id=034bda35&lang=scss"

const __exports__ = script;

export default __exports__